import { DeviceType } from '@/constants/deviceTypeEnum';
import { MetricType } from '@/constants/metric-type.enum';

export enum EditableField {
  ORDER = 'order',
  LOAD = 'load',
  UNLOAD = 'unload',
  TARGET = 'target',
  AUTO = 'auto',
  IMMEDIATE = 'immediate',
  BAND = 'band',
  MODULATION = 'modulation',
  PRESSURE_DROP = 'pressureDrop',
}

export enum DeviceAttributes {
  Name = 'name',
  Capacity = 'capacity',
  PipeDiameter = 'pipeDiameter',
  PipeMaterial = 'pipeMaterial',
  LastService = 'lastService',
  InMaintenance = 'inMaintenance',
  IsDisabled = 'isDisabled',
  DefaultSetPoints = 'defaultSetPoints',
  CycleMinutes = 'cycleMinutes',
  LastHourDuty = 'lastHourDuty',
  DutyLastUpdate = 'dutyLastUpdate',
  DryerTemperatureTargetCelsius = 'dryerTemperatureTargetCelsius',
  OverrideParent = 'overrideParent',
  KeepAliveEnabled = 'keepAliveEnabled',
  KeepAliveEverySeconds = 'keepAliveEverySeconds',
  KeepAliveAlwaysOn = 'keepAliveAlwaysOn',
  AdditionalDisplayMetrics = 'additionalDisplayMetrics',
  CompressorNumber = 'compressorNumber',
  MinPressureThreshold = 'minPressureThreshold',
  MaxPressureThreshold = 'maxPressureThreshold',
  SerialNumber = 'serialNumber',
  CareProgram = 'careProgram',
  Priority = 'priority',
  BandsControl = 'bandsControl',
  LineToLineVolt = 'lineToLineVolt',
  BlowerNumber = 'blowerNumber',
  MeasurementUnit = 'measurementUnit',
  MinimumDissolvedOxygenPPM = 'minimumDissolvedOxygenPPM',
  MaximumDissolvedOxygenPPM = 'maximumDissolvedOxygenPPM',
  TargetDissolvedOxygenPPM = 'targetDissolvedOxygenPPM',
  MaxLoadAmps = 'maxLoadAmps',
  MaxFlow = 'maxFlow',
}

export interface MetricValueMappings {
  metricName: MetricType;
  valueMappings: ValueMapping[];
}

export interface ValueMapping {
  inputValue: number | string;
  outputValue: string;
}

export interface DeviceMetadata {
  id: string;
  name: string;
  deviceTypes: (DeviceType | 'station')[];
  deviceModel?: unknown;
  elementIndex?: number;
  metrics: MetricType[];
  actions?: string[];
  parentDeviceId?: string;
  parentDeviceName?: string;
  stringValueMappings: MetricValueMappings[];
  attributes: Partial<Record<DeviceAttributes, unknown>>;
  editableFields?: EditableField[];
}
